import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

const initialState = {
    signInModalOpen: false,
    postSignInCallback: null,
    loading: false,
    error: null,
}

// Async thunks
export const updateSignInModalState = createAsyncThunk(
    "auth/updateSignInModalState",
    async (isOpen, { rejectWithValue }) => {
        try {
            // Simulate an API call
            return isOpen
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

// Auth slice
const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        openSignInModal: (state, action) => {
            state.signInModalOpen = true
            state.postSignInCallback = action.payload?.callback || null;
        },
        closeSignInModal: (state) => {
            state.signInModalOpen = false
            state.postSignInCallback = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateSignInModalState.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(updateSignInModalState.fulfilled, (state, action) => {
                state.loading = false
                state.signInModalOpen = action.payload
            })
            .addCase(updateSignInModalState.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    },
})

// Export actions
export const { openSignInModal, closeSignInModal } = authSlice.actions
// Export reducer
export default authSlice.reducer

// Selectors
export const selectSignInModalState = (state) => state.auth.signInModalOpen
export const selectLoading = (state) => state.auth.loading
export const selectError = (state) => state.auth.error